<template>
  <div id="app" class="main-container">
    <div class="main-container__hC">
      <div class="main-container__hC__header">
        <img class="main-container__hC__header__img" src="./assets/image/logo.png" alt="logo">
        <div class="main-container__hC__header__menus">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :router="true">
            <el-menu-item index="home"><span>首页</span></el-menu-item>
            <el-menu-item index="consultingCenter"><span>咨询中心</span></el-menu-item>
            <el-menu-item index="aboutUs"><span>关于我们</span></el-menu-item>
            <el-menu-item index="contactUs"><span>联系我们</span></el-menu-item>
            <el-menu-item index="addUs"><span>加入我们</span></el-menu-item>
          </el-menu>
        </div>
      </div>
      </div>
    <router-view/>
    <div class="main-container__footer">
      <ul>
        <li @click="changePage('home')">首页</li>
        <li>|</li>
        <li @click="changePage('consultingCenter')">咨询中心</li>
        <li>|</li>
         <li @click="changePage('aboutUs')">关于我们</li>
        <li>|</li>
         <li @click="changePage('contactUs')">联系我们</li>
        <li>|</li>
         <li @click="changePage('addUs')">加入我们</li>
      </ul>
      <div>
        <span>Copyright@2020-2025 上海越联信息科技有限公司
          <a href="https://beian.miit.gov.cn">
            <img src="./assets/image/beian.png" alt="beian">
            沪ICP备2021016742号-1
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      activeIndex:'home'
    }
  },
  methods:{
    changePage(name){
      this.activeIndex=name;
      this.$router.push({name:name})
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666;
  background-color: #F8F8F8;
}
.main-container{
  &__hC{
    background-color: #fff;
    &__header{
      max-width: 1920px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      height: 100px;
      &__img{
        height: 80px;
        margin: 10px 0px 0px 10px;
      }
      ul{
        display: flex;
        list-style: none;
        border-bottom: none;
        height: 100%;
        li{
          border-bottom: none;
          line-height: 100px;
          height: 100%;
          &.el-menu-item.is-active{
            border-bottom: none;
            color: #333;
            span::after{
                  content: "";
                  display: inline-block;
                  position: absolute;
                  bottom: 15px;
                  left: calc(50% - 7px);
                  width: 14px;
                  height: 4px;
                  background: #409eff;
            }
          }
        }
        span{
          cursor: pointer;
          font-family: webfont__regular;
          font-size: 17px;
        }
      }
    }
  }
  &__footer{
    width: 100%;
    background-color: #1B2336;
    color: #fff;
    padding: 38px;
    font-size: 16px;
    ul{
      list-style: none;
      margin-bottom: 34px;
      li{
        display: inline-block;
        margin: 0 10px;
        font-family: webfont__regular;
        color: #fff;
        cursor: pointer;
        &:hover{
          text-decoration: underline;
        }
      }
    }
    .logo{
      width: 20px;
      height: 20px;
    }
    span{
      font-family: webfont__light;
      opacity: 0.7;
      a{
        color: #fff;
        img{
          position: relative;
          top: 2px;
        }
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue